export default __webpack_public_path__ + "b9d136deac46958a9ee51e2f8f18717b.svg";